import React, { useEffect, useState } from "react";
import axios from "axios";
import { useSnackbar } from "notistack";
import { BASE_URL } from "../../utils/BaseURL";
import StarRating from "../SingleProduct/StarRating";

const Reviews = ({ data }) => {
  const { user } = JSON.parse(localStorage.getItem("user")) || {};

  const [formData, setFormData] = useState({
    product: data._id,
    user: "",
    rating: 0,
    comment: "",
  });
  const [review, setreview] = useState([]);
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setloading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  useEffect(() => {
    axios
      .get(`${BASE_URL}/review/${data._id}`)
      .then((res) => setreview(res.data.data));
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    setloading(true);
    // setFormData({...formDatam,  user: user._id, });
    // TODO: Add code to handle submission of the review data (e.g., send it to a server)
    axios.post(BASE_URL + "/review", formData).then(() => {
      enqueueSnackbar("Review Posted", { variant: "success" });
      setloading(false);
    });
    console.log("Form submitted:", formData);
    setFormData({ product: data._id, user: user._id, rating: 0, comment: "" }); // Reset form fields
  };

  console.log(review);
  return (
    <div className="bg-white p-4 rounded shadow">
      {review?.map((item) => (
        <div key={item?._id} className="mb-4 border-b pb-4">
          <div className="  flex items-center gap-5">
            <div className="font-bold text-xl mb-2">{item?.user.name}</div>
            <StarRating rating={item?.rating} />
          </div>
          <div className="text-gray-700">{item?.comment}</div>
        </div>
      ))}
      {data &&
        data.reviews &&
        data?.reviews?.map((item) => (
          <div key={item?._id} className="mb-4 border-b pb-4">
            <div className="  flex items-center gap-5">
              <div className="font-bold text-xl mb-2">{item?.username}</div>
              <StarRating rating={item?.rating} />
            </div>
            <div className="text-gray-700">{item?.comment}</div>
          </div>
        ))}
      <div className="mt-4 border-t pt-4">
        <h2 className="text-xl font-bold mb-2">Add Review</h2>
        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label
              className="block text-gray-700 text-sm font-bold mb-2"
              htmlFor="rating"
            >
              Rating:
            </label>
            <span
              onClick={() => setFormData({ ...formData, rating: 1 })}
              className={` ${
                formData.rating >= 1 ? "text-yellow-500" : "text-gray-500"
              } `}
            >
              &#9733;
            </span>
            <span
              onClick={() => setFormData({ ...formData, rating: 2 })}
              className={` ${
                formData.rating >= 2 ? "text-yellow-500" : "text-gray-500"
              } `}
            >
              &#9733;
            </span>
            <span
              onClick={() => setFormData({ ...formData, rating: 3 })}
              className={` ${
                formData.rating >= 3 ? "text-yellow-500" : "text-gray-500"
              } `}
            >
              &#9733;
            </span>
            <span
              onClick={() => setFormData({ ...formData, rating: 4 })}
              className={` ${
                formData.rating >= 4 ? "text-yellow-500" : "text-gray-500"
              } `}
            >
              &#9733;
            </span>
            <span
              onClick={() => setFormData({ ...formData, rating: 5 })}
              className={` ${
                formData.rating >= 5 ? "text-yellow-500" : "text-gray-500"
              } `}
            >
              &#9733;
            </span>
            {/* <StarRating
              rating={formData.rating}
              onChange={(value) => setFormData({ ...formData, rating: value })}
            /> */}
          </div>
          <div className="mb-4">
            <label
              className="block text-gray-700 text-sm font-bold mb-2"
              htmlFor="comment"
            >
              Comment:
            </label>
            <textarea
              className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
              id="comment"
              placeholder="Write your review here"
              name="comment"
              value={formData.comment}
              onChange={handleChange}
              required
            />
          </div>
          <button
            className="bg-[#FF324D]  text-black font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
            type="submit"
          >
            {loading === true ? "loading" : "Submit Review"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Reviews;
